import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, orderBy, getDocs, addDoc } from 'firebase/firestore';

const ESTADO_LABEL = { proximo: 'Próximo', realizado: 'Realizado', suspendido: 'Suspendido' };
const ESTADO_COLOR = { proximo: '#1d4ed8', realizado: '#15803d', suspendido: '#b91c1c' };
const MODALIDAD_ICON = { presencial: '📍 Presencial', online: '💻 Online', mixto: '📍💻 Mixto' };

function fmtFecha(valor) {
  const d = valor?.toDate ? valor.toDate() : (valor ? new Date(valor) : null);
  if (!d || isNaN(d.getTime())) return '';
  return d.toLocaleString('es-AR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function Remates() {
  const [remates, setRemates] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(false);

  // Suscripción a alertas de nuevos remates
  const [emailSub, setEmailSub] = useState('');
  const [suscribiendo, setSuscribiendo] = useState(false);
  const [subOk, setSubOk] = useState(false);
  const [subError, setSubError] = useState('');

  const suscribirRemates = async (e) => {
    e.preventDefault();
    setSubError('');
    const email = emailSub.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setSubError('Ingresá un email válido.'); return; }
    setSuscribiendo(true);
    try {
      await addDoc(collection(db, 'suscripcionesRemates'), {
        email,
        token: crypto.randomUUID(),
        activa: true,
        creadoEn: new Date(),
      });
      setSubOk(true);
      setEmailSub('');
    } catch {
      setSubError('No se pudo completar la suscripción. Intentá de nuevo más tarde.');
    }
    setSuscribiendo(false);
  };

  useEffect(() => {
    async function cargar() {
      try {
        // Auto-archivado: solo remates futuros (margen de 12 h para los del día).
        const desde = new Date();
        desde.setHours(desde.getHours() - 12);
        let docs;
        try {
          const q = query(
            collection(db, 'remates'),
            where('publicada', '==', true),
            where('fechaHora', '>=', desde),
            orderBy('fechaHora', 'asc')
          );
          docs = (await getDocs(q)).docs;
        } catch (e) {
          // Fallback sin índice compuesto: traer publicadas y filtrar/ordenar en cliente
          const q2 = query(collection(db, 'remates'), where('publicada', '==', true));
          docs = (await getDocs(q2)).docs;
        }
        let arr = docs.map(d => ({ id: d.id, ...d.data() }));
        arr = arr.filter(r => {
          if (r.eliminado) return false;
          const d = r.fechaHora?.toDate ? r.fechaHora.toDate() : new Date(r.fechaHora);
          return d && !isNaN(d.getTime()) && d >= desde;
        });
        arr.sort((a, b) => {
          const da = a.fechaHora?.toDate ? a.fechaHora.toDate() : new Date(a.fechaHora);
          const dbb = b.fechaHora?.toDate ? b.fechaHora.toDate() : new Date(b.fechaHora);
          return da - dbb;
        });
        setRemates(arr);
      } catch (err) {
        console.error('Error cargando remates:', err);
        setError(true);
      }
      setCargando(false);
    }
    cargar();
  }, []);

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px', boxSizing: 'border-box' }}>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: '30px', color: '#1e3a6e' }}>🔨 Remates</h1>
        <p style={{ margin: 0, color: '#555', fontSize: '15px' }}>
          Agenda de remates judiciales a cargo de los martilleros asociados a la CIF.
        </p>
      </div>

      {cargando ? (
        <p style={{ color: '#888', textAlign: 'center', padding: '40px' }}>Cargando agenda de remates…</p>
      ) : error ? (
        <p style={{ color: '#dc3545', textAlign: 'center', padding: '40px' }}>No se pudo cargar la agenda. Intentá de nuevo.</p>
      ) : remates.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', background: '#fafafa', borderRadius: '14px', border: '1px dashed #ddd' }}>
          <p style={{ fontSize: '48px', margin: '0 0 12px' }}>🔨</p>
          <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>No hay remates programados en este momento.</p>
          <p style={{ color: '#999', fontSize: '14px', margin: '6px 0 0' }}>Volvé a consultar más adelante.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {remates.map(r => (
            <Link key={r.id} to={r.slug ? `/remate/${r.slug}` : `/remate/${r.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div
                style={{ display: 'flex', gap: '0', background: 'white', borderRadius: '14px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.06)', border: '1px solid #eee', transition: 'transform 0.15s, box-shadow 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 22px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)'; }}
              >
                <img
                  src={r.fotoUrl || r.fotosThumbs?.[0] || r.fotosUrls?.[0] || '/sin-imagen.svg'}
                  onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/sin-imagen.svg'; }}
                  alt="" style={{ width: '180px', minHeight: '140px', objectFit: 'cover', background: '#f0f0f0', flexShrink: 0 }}
                />
                <div style={{ padding: '16px 20px', flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '8px' }}>
                    <span style={{ background: '#eef2ff', color: '#4f46e5', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>{r.tipoBien}</span>
                    <span style={{ background: '#f3f4f6', color: ESTADO_COLOR[r.estado] || '#555', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>{ESTADO_LABEL[r.estado] || r.estado}</span>
                    <span style={{ color: '#666', fontSize: '12px' }}>{MODALIDAD_ICON[r.modalidad] || r.modalidad}</span>
                  </div>
                  <h3 style={{ margin: '0 0 6px', fontSize: '18px', color: '#1a1a1a' }}>
                    {r.caratula || r.descripcion || 'Bien en remate'}
                  </h3>
                  <p style={{ margin: '0 0 8px', fontSize: '14px', color: '#1e3a6e', fontWeight: '600', textTransform: 'capitalize' }}>
                    📅 {fmtFecha(r.fechaHora)} hs
                  </p>
                  {r.base != null && (
                    <p style={{ margin: 0, fontSize: '14px', color: '#444' }}>
                      <strong>Base:</strong> {r.moneda === 'USD' ? 'U$S' : '$'} {Number(r.base).toLocaleString('es-AR')}
                    </p>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {/* ── SUSCRIPCIÓN A NUEVOS REMATES ── */}
      <div style={{ marginTop: '36px', background: '#f0f7ff', border: '1px solid #cfe2ff', borderRadius: '14px', padding: '28px 24px' }}>
        {subOk ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontSize: '38px', margin: '0 0 8px' }}>✅</p>
            <h3 style={{ margin: '0 0 6px', fontSize: '18px', color: '#1e3a6e' }}>¡Listo, quedaste suscripto!</h3>
            <p style={{ margin: 0, color: '#555', fontSize: '14px' }}>
              Te vamos a avisar por email cada vez que se publique un remate nuevo. Podés darte de baja cuando quieras desde el mismo email.
            </p>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div style={{ flex: '1 1 280px', minWidth: '260px' }}>
              <h3 style={{ margin: '0 0 6px', fontSize: '18px', color: '#1e3a6e' }}>🔔 Enterate de los nuevos remates</h3>
              <p style={{ margin: 0, color: '#555', fontSize: '14px', lineHeight: 1.5 }}>
                Dejanos tu email y te avisamos apenas se publique un remate nuevo en la agenda.
              </p>
            </div>
            <form onSubmit={suscribirRemates} style={{ flex: '1 1 300px', minWidth: '260px' }}>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                <input
                  type="email" value={emailSub} onChange={e => setEmailSub(e.target.value)}
                  placeholder="tucorreo@ejemplo.com"
                  style={{ flex: 1, minWidth: '180px', padding: '12px 14px', border: '1px solid #b6d4fe', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
                <button type="submit" disabled={suscribiendo}
                  style={{ padding: '12px 22px', background: suscribiendo ? '#6c757d' : '#1e3a6e', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '14px', cursor: suscribiendo ? 'wait' : 'pointer', whiteSpace: 'nowrap' }}>
                  {suscribiendo ? 'Suscribiendo…' : 'Avisame'}
                </button>
              </div>
              {subError && <p style={{ color: '#dc3545', fontSize: '13px', margin: '8px 0 0' }}>{subError}</p>}
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
